import PdfGrid from "../layout/PdfGrid";
import PdfRow from "../layout/PdfRow";
import PdfLabel from "../typography/PdfLabel";
import PdfValue from "../typography/PdfValue";

const PdfBuilderDataItemRow = ({
  label,
  value,
  type,
  style,
  center,
  valueStyle,
  labelStyle,
}) => {
  return (
    <PdfRow style={style}>
      <PdfGrid columns={2} gap={5} style={style}>
        <PdfLabel style={labelStyle}>{label}</PdfLabel>
        <PdfValue type={type} style={valueStyle}>
          {value}
        </PdfValue>
      </PdfGrid>
    </PdfRow>
  );
};

export default PdfBuilderDataItemRow;
